(function () {
  const YES_WORDS = ['yes'];
  const LINING_WORDS = ['lining'];
  const LINING_TYPES = [
    'white cotton',
    'natural linen',
    'blackout',
    'unbleached cotton',
    'bleached cotton',
    'cotton privacy'
  ];

  function cleanText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeSize(value) {
    const match = String(value || '').match(/\d+/);
    return match ? match[0] : '';
  }

  function formEntries(formData) {
    return Array.from(formData.entries()).map(([key, value]) => ({
      key: String(key),
      value: String(value),
      haystack: cleanText(`${key} ${value}`)
    }));
  }

  function customerWantsLining(entries) {
    return entries.some((entry) => {
      const mentionsLining = LINING_WORDS.some((word) => entry.haystack.includes(word));
      const saysYes = YES_WORDS.some((word) => cleanText(entry.value) === word || entry.haystack.includes(` ${word} `));
      return mentionsLining && saysYes;
    });
  }

  function productHasLiningOption(form, entries) {
    if (entries.some((entry) => LINING_WORDS.some((word) => entry.haystack.includes(word)))) {
      return true;
    }

    const productInfo =
      form.closest('[id^="ProductInfo-"]') ||
      form.closest('.product__info-container') ||
      form.closest('product-info');

    if (!productInfo) return false;

    const optionNodes = productInfo.querySelectorAll(
      'input, select, textarea, label, legend, fieldset, [data-option-name], [data-name], [class*="easify" i]'
    );

    return Array.from(optionNodes).some((node) => {
      const optionText = cleanText(
        [
          node.textContent,
          node.getAttribute('name'),
          node.getAttribute('value'),
          node.getAttribute('aria-label'),
          node.getAttribute('data-option-name'),
          node.getAttribute('data-name')
        ].join(' ')
      );

      return optionText.includes('add lining') || optionText.includes('lining type');
    });
  }

  function selectedLiningType(entries) {
    const matchingEntry = entries.find((entry) =>
      LINING_TYPES.some((type) => entry.haystack.includes(type))
    );

    if (!matchingEntry) return '';

    return LINING_TYPES.find((type) => matchingEntry.haystack.includes(type)) || matchingEntry.value;
  }

  function getFormValue(formData, name) {
    return formData.get(name) || formData.get(`options[${name}]`) || '';
  }

  function getVariantPicker(form) {
    const formId = form.getAttribute('id');

    if (!formId) return document.querySelector('variant-selects, variant-radios');

    const sectionId = formId.replace('product-form-', '');

    return (
      document.querySelector(`variant-selects[data-section="${sectionId}"]`) ||
      document.querySelector(`variant-radios[data-section="${sectionId}"]`) ||
      document.querySelector('variant-selects, variant-radios')
    );
  }

  function getVariantById(form, variantId) {
    const picker = getVariantPicker(form);
    const variantJson = picker?.querySelector('script[type="application/json"]');

    if (!variantJson) return null;

    try {
      return JSON.parse(variantJson.textContent).find((variant) => Number(variant.id) === Number(variantId)) || null;
    } catch (error) {
      console.error('Could not read curtain variant data.', error);
      return null;
    }
  }

  function getSelectedCurtainVariant(form, formData) {
    return getVariantById(form, Number(formData.get('id')));
  }

  function getSelectedSize(form, formData, variantId) {
    const selectedVariant = getVariantById(form, variantId);

    if (selectedVariant) {
      return {
        width: normalizeSize(selectedVariant.option1),
        length: normalizeSize(selectedVariant.option2)
      };
    }

    return {
      width: normalizeSize(getFormValue(formData, 'Width')),
      length: normalizeSize(getFormValue(formData, 'Length'))
    };
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function getPriceNotice(form) {
    let notice = form.querySelector('[data-lining-price-notice]');

    if (!notice) {
      notice = document.createElement('div');
      notice.setAttribute('data-lining-price-notice', '');
      notice.style.margin = '1rem 0';
      notice.style.fontSize = '1.4rem';
      notice.style.lineHeight = '1.4';
      notice.style.display = 'none';

      const buttons = form.querySelector('.product-form__buttons') || form.querySelector('[type="submit"]');

      if (buttons) {
        buttons.parentNode.insertBefore(notice, buttons);
      } else {
        form.appendChild(notice);
      }
    }

    return notice;
  }

  function getPanelPriceNote() {
    let note = document.querySelector('[data-panel-price-note]');

    if (!note) {
      note = document.createElement('div');
      note.setAttribute('data-panel-price-note', '');
      note.style.marginTop = '0.5rem';
      note.style.fontSize = '1.3rem';
      note.style.lineHeight = '1.4';
      note.style.opacity = '0.75';
      note.textContent = 'Price shown is for one curtain panel. Estimated total updates below when quantity or lining options change.';

      const priceBlock = document.querySelector('.product__price');

      if (priceBlock) {
        priceBlock.appendChild(note);
      }
    }

    return note;
  }

  function hidePriceMessaging(form) {
    const notice = form.querySelector('[data-lining-price-notice]');
    const panelNote = document.querySelector('[data-panel-price-note]');

    if (notice) {
      notice.style.display = 'none';
      notice.innerHTML = '';
    }

    if (panelNote) {
      panelNote.remove();
    }
  }

  function updatePriceNotice(form) {
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    if (!window.LindenLiningVariantMap?.variantsBySize) return;

    const formData = new FormData(form);
    const entries = formEntries(formData);

    if (!productHasLiningOption(form, entries)) {
      hidePriceMessaging(form);
      return;
    }

    getPanelPriceNote();

    const notice = getPriceNotice(form);
    const curtainVariantId = Number(formData.get('id'));
    const curtainVariant = getSelectedCurtainVariant(form, formData);
    const selectedSize = getSelectedSize(form, formData, curtainVariantId);
    const sizeKey = `${selectedSize.width}x${selectedSize.length}`;
    const liningVariant = window.LindenLiningVariantMap.variantsBySize[sizeKey];
    const quantity = Number(formData.get('quantity') || 1);

    if (!curtainVariant) {
      notice.style.display = 'none';
      notice.innerHTML = '';
      return;
    }

    const wantsLining = customerWantsLining(entries);
    const curtainTotal = Number(curtainVariant.price) * quantity;
    const liningTotal = wantsLining && liningVariant ? Number(liningVariant.price) * quantity : 0;
    const combinedTotal = curtainTotal + liningTotal;

    notice.style.display = 'block';
    notice.innerHTML = wantsLining
      ? `
        <strong>Curtain subtotal:</strong> ${formatMoney(curtainTotal)}
        <br>
        <strong>Lining added:</strong> ${formatMoney(liningTotal)}
        <br>
        <strong>Estimated total:</strong> ${formatMoney(combinedTotal)}
      `
      : `
        <strong>Estimated total for ${quantity} panel${quantity === 1 ? '' : 's'}:</strong> ${formatMoney(combinedTotal)}
      `;
  }

  function getLineItemProperties(formData) {
    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match = String(key).match(/^properties\[(.+)]$/);

      if (match && value !== '') {
        properties[match[1]] = String(value);
      }
    }

    return properties;
  }

  function buildLiningProperties(width, length, liningType) {
    return {
      'Add lining': 'Yes',
      'Lining type': liningType,
      'Curtain width': `${width} inches`,
      'Curtain length': `${length} inches`
    };
  }

  async function addItems(items) {
    const response = await fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    });

    const body = await response.json();

    if (!response.ok || body.status) {
      throw new Error(body.description || body.message || 'Could not add lining to cart.');
    }

    return body;
  }

  function bindPriceNotices() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      updatePriceNotice(form);
    });
  }

  function schedulePriceNoticeUpdate(event) {
    const form =
      event.target?.closest?.('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');

    if (!form) return;

    updatePriceNotice(form);
    window.setTimeout(() => updatePriceNotice(form), 100);
    window.setTimeout(() => updatePriceNotice(form), 300);
  }

  document.addEventListener('change', schedulePriceNoticeUpdate);
  document.addEventListener('click', schedulePriceNoticeUpdate);
  document.addEventListener('input', schedulePriceNoticeUpdate);

  document.addEventListener('DOMContentLoaded', () => {
    bindPriceNotices();
    window.setTimeout(bindPriceNotices, 500);
    window.setTimeout(bindPriceNotices, 1500);
  });
  document.addEventListener('shopify:section:load', bindPriceNotices);

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target;

      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      if (!window.LindenLiningVariantMap?.variantsBySize) return;

      const formData = new FormData(form);
      const entries = formEntries(formData);

      if (!customerWantsLining(entries)) return;

      const curtainVariantId = Number(formData.get('id'));
      const selectedSize = getSelectedSize(form, formData, curtainVariantId);
      const width = selectedSize.width;
      const length = selectedSize.length;
      const sizeKey = `${width}x${length}`;
      const liningVariant = window.LindenLiningVariantMap.variantsBySize[sizeKey];
      const liningType = selectedLiningType(entries);
      const quantity = Number(formData.get('quantity') || 1);
      const curtainProperties = getLineItemProperties(formData);

      if (!width || !length || !liningVariant || !curtainVariantId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        alert('Please choose a curtain width and length before adding lining.');
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[type="submit"]');

      try {
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }

        await addItems([
          {
            id: curtainVariantId,
            quantity,
            properties: curtainProperties
          },
          {
            id: liningVariant.id,
            quantity,
            properties: buildLiningProperties(width, length, liningType || 'Selected')
          }
        ]);

        window.location.href = window.routes?.cart_url || '/cart';
      } catch (error) {
        console.error(error);
        alert(error.message);

        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
      }
    },
    true
  );
})();
